import * as S from './Loading.styled'

const Loading = ({ inline }) => (
  <S.Loading $inline={inline}>
    <S.LoadingIcon />
  </S.Loading>
)

export default Loading
